import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  completeSpotifyAuth,
  getAuthCallbackParams,
  restoreSpotifySession,
} from '../auth';

const TokenHandler = ({ setToken, setAuthError, setAuthReady }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const restoreSession = async () => {
      const { code, state, error } = getAuthCallbackParams();
      let ownsProcessingLock = false;
      try {
        if (error) throw new Error('Spotify login was cancelled or denied.');

        if (code) {
          if (sessionStorage.getItem('spotifyAuthProcessing')) return;
          sessionStorage.setItem('spotifyAuthProcessing', 'true');
          ownsProcessingLock = true;
          const { token, returnPath } = await completeSpotifyAuth(code, state);
          setToken(token);
          navigate(returnPath, { replace: true });
          return;
        }

        setToken(await restoreSpotifySession());
      } catch (authError) {
        setAuthError(authError.message);
        setToken(null);
      } finally {
        if (ownsProcessingLock) sessionStorage.removeItem('spotifyAuthProcessing');
        setAuthReady(true);
      }
    };

    restoreSession();
  }, [navigate, setAuthError, setAuthReady, setToken]);

  return null;
};

export default TokenHandler;
